import React from 'react';
import {
  Table, Space, DatePicker, Input,
} from 'antd';
import { useTranslation } from 'react-i18next';

import withAuth from '@common/hocs/withAuth';
import MainLayout from '@common/layouts/MainLayout';

import useAlarmas_Notifications from './useAlarmas_Notifications';
import styles from './Alarmas_Notifications.module.less';

const { RangePicker } = DatePicker;

function Alarmas_Notifications() {

  const { t } = useTranslation();
  const {
    onChangeRangeDate,
    pagination,
    loading,
    columns,
    dataSource,
    defaultRangeValue,
    onSearch,
    handleTableChange,
  } = useAlarmas_Notifications();

  return (
    <MainLayout applyWidthLimit>
      <Space size="large" style={{ marginBottom: 24 }}>
        <RangePicker
          showTime
          onChange={onChangeRangeDate}
          defaultValue={defaultRangeValue}
          allowClear={false}
        />
        <Input.Search
          enterButton
          allowClear
          onSearch={onSearch}
          loading={loading}
          placeholder={t('common.find')}
        />
      </Space>

      <Table
        className={styles.table}
        loading={loading}
        columns={columns}
        dataSource={dataSource}
        pagination={pagination}
        onChange={handleTableChange}
        rowKey={({ uuid }) => `${uuid}`}
        scroll={{ x: 1100 }}
      />
    </MainLayout>
  );

}

export default withAuth(Alarmas_Notifications);
